<template>
    <b-modal id="confirmdecline" ref="decline-modal" :hide-header="true" :hide-footer="true"
             :centered="true">
        <div class="modal-body">
            <a href="#" role="button" class="close pos-absolute t-15 r-15" data-dismiss="modal"
               aria-label="Close" @click="hidedec">
                <span aria-hidden="true">&times;</span>
            </a>

            <div>
                <h4>Confirm Decline</h4>
                <p class="tx-color-03">Confirm Decline</p>
                <b-form>

                    <b-form-group label="Input Password:">
                        <b-form-input
                                type="password"
                                id="narration"
                                v-model="password"
                                required
                        ></b-form-input>

                    </b-form-group>

                    <b-button v-if="ft.batchLoading" disabled
                              class="btn-secondary btn-brand-02 btn-block">
                                        <span class="spinner-border spinner-border-sm" role="status"
                                              aria-hidden="true"></span>
                        Loading...
                    </b-button>
                    <b-button v-else @click="decline" type="submit" class="btn btn-secondary btn-block btn-sm">Submit
                    </b-button>

                </b-form>


            </div>
        </div><!-- modal-body -->
    </b-modal>
</template>
<script>
    import {mapState} from "vuex";

    export default {
        name: 'DeclineModal',
        data(){
            return{
                password: ''
            }
        },
        methods:{
            decline: async function () {
                let model = {
                    customerid: this.auth.response.customerid,
                    batchid: this.ft.batchDetails.batchid,
                    password: this.password
                };
                this.$refs['decline-modal'].hide();
                let result = await this.$store.dispatch("ft/callDeclineTransaction", model, {root: false});
                this.$swal({
                    title: result.responsecode === '00' ? 'Success' : 'Warning',
                    showClass: {
                        popup: 'animated slideInLeft faster display-6'
                    },
                    hideClass: {
                        popup: 'animated slideOutRight faster display-6'
                    },
                    text: result.responsemessage,
                    icon: result.responsecode === '00' ? 'success' : 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'Ok'
                });
                const payload = {customerid: this.auth.response.customerid, status: 'completed'};
                this.password = '';
                await this.$store.dispatch("ft/readAllBatches", payload, {root: false});
            },
            hidedec: function () {
                this.password = '';
                this.$refs['decline-modal'].hide();
            },


        },
        computed:{
            ...mapState(['ft', 'auth'])
        }
    }
</script>
